import { ContactHandler, UserEntityInterface } from '@types';
import { ContactHandlerKeys } from '@enums';

export const contactHandlers: Map<ContactHandlerKeys, ContactHandler> = new Map([
  [ContactHandlerKeys.PHONE, (val: string) => `tel:${val}`],
  [ContactHandlerKeys.EMAIL, (val: string) => `mailto:${val}`],
  [ContactHandlerKeys.SKYPE, (val: string) => `skype:${val}?chat`],
  [ContactHandlerKeys.ROOM, () => ''],
  [ContactHandlerKeys.TELEGRAM, (val: string) => `https://t.me/${val}`],
  [ContactHandlerKeys.INSTAGRAM, (val: string) => `https://www.instagram.com/${val}/`],
  [ContactHandlerKeys.VK, (val: string) => `https://vk.com/${val}`],
  [ContactHandlerKeys.GITHUB, (val: string) => `https://github.com/${val}`],
  [ContactHandlerKeys.TWITTER, (val: string) => `https://twitter.com/${val}`],
  [ContactHandlerKeys.BITBUCKET, (val: string) => `https://bitbucket.com/${val}`],
  [ContactHandlerKeys.FACEBOOK, (val: string) => `https://facebook.com/${val}`],
]);

export const contactTitles: Map<ContactHandlerKeys, ContactHandler> = new Map([
  [ContactHandlerKeys.PHONE, () => `Phone`],
  [ContactHandlerKeys.EMAIL, () => `Email`],
  [ContactHandlerKeys.SKYPE, () => `Skype`],
  [ContactHandlerKeys.ROOM, () => 'Workplace'],
  [ContactHandlerKeys.TELEGRAM, () => `Telegram`],
  [ContactHandlerKeys.INSTAGRAM, () => `Instagram`],
  [ContactHandlerKeys.VK, () => `VK`],
  [ContactHandlerKeys.GITHUB, () => `GitHub`],
  [ContactHandlerKeys.TWITTER, () => `Twitter`],
  [ContactHandlerKeys.BITBUCKET, () => `Bitbucket`],
  [ContactHandlerKeys.FACEBOOK, () => `Facebook`],
]);

const unhiddenContacts = ['room', 'phone', 'skype'];

const unhiddenVentionContacts = ['room', 'phone', 'skype', 'email'];

export const addContacts = (
  answerData,
  owner: UserEntityInterface,
  { withoutSkype = false, withoutPhone = false } = {}
) => {
  answerData.socialNetworks = answerData.socialNetworks || {};

  if (owner.email) {
    answerData.socialNetworks.email = owner.email;
  }

  if (!withoutSkype && owner.skype) {
    answerData.socialNetworks.skype = owner.skype;
  }

  if (!withoutPhone && owner.phone) {
    answerData.socialNetworks.phone = owner.phone;
  }

  if (owner.workplace) {
    answerData.socialNetworks.room = owner.workplace.fullName;
  }

  answerData.socialNetworks = Object.keys(answerData.socialNetworks).map(
    (key: ContactHandlerKeys) => {
      const keyHandler = contactHandlers.get(key);

      const title = contactTitles.get(key);

      const href = keyHandler
        ? keyHandler(answerData.socialNetworks[key])
        : answerData.socialNetworks[key];

      return {
        key,
        data: unhiddenContacts.includes(key) ? answerData.socialNetworks[key] : 'Click me',
        href,
        title: title(answerData.socialNetworks[key]),
        ventionData: unhiddenVentionContacts.includes(key)
          ? answerData.socialNetworks[key]
          : `@${answerData.socialNetworks[key]}`,
      };
    }
  );
  const converted = [];
  for (let i = 0; i < answerData.socialNetworks.length; i += 2) {
    const resultItem = [];
    resultItem.push(answerData.socialNetworks[i]);
    if (answerData.socialNetworks[i + 1]) {
      resultItem.push(answerData.socialNetworks[i + 1]);
    }
    converted.push(resultItem.reverse());
  }
  converted.reverse();
  answerData.socialNetworks = converted;

  return answerData;
};
